<template>
<div class="chapter">
<div class="inner_page">
<p class="lefth1"><span><span class="hide">                </span><span epub:type="pagebreak" id="page_ix" title="ix"><i>Our world in stupor lies;</i></span></span></p>
<p class="lefth"><span><span class="hide">                </span><i>Yet, dotted everywhere,</i></span></p>
<p class="lefth"><span><span class="hide">                </span><i>Ironic points of light</i></span></p>
<p class="lefth"><span><span class="hide">                </span><i>Flash out wherever the Just</i></span></p>
<p class="lefth"><span><span class="hide">                </span><i>Exchange their messages</i></span></p>
<p class="lefth-ts"><span><span class="hide">                </span><i>— W. H. Auden, “September 1, 1939”</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter1.vue?6e1ef8a3